import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

/** Route for /signin-callback.html */
const SigninCallback = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const ACCESS_DENIED = "access_denied";
  const isDeniedAccess = (auth.error?.message === ACCESS_DENIED);
  useEffect(() => {
    if (isDeniedAccess) {
      navigate("/");
    }

  }, [navigate])

  return <div>SigninCallback</div>
}

export default SigninCallback;